// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__2UJGB","second":"return_second__1aR6y","link":"return_link__9Hn8t"};